import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import clsx from 'clsx';

/**
 * Modal reutilizável
 * Props: aberto, onFechar, titulo, children, tamanho ('sm' | 'md' | 'lg' | 'xl')
 */
export default function Modal({ aberto, onFechar, titulo, children, tamanho = 'md' }) {
  // Fechar com ESC
  useEffect(() => {
    if (!aberto) return;
    const handler = (e) => e.key === 'Escape' && onFechar();
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [aberto, onFechar]);

  // Travar scroll do body
  useEffect(() => {
    document.body.style.overflow = aberto ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [aberto]);

  if (!aberto) return null;

  const larguras = {
    sm: 'max-w-sm',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl',
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onFechar}
      />

      {/* Conteúdo */}
      <div className={clsx(
        'relative w-full bg-[#0a0f1e] border border-surface-border rounded-2xl shadow-2xl',
        'max-h-[90vh] flex flex-col',
        larguras[tamanho]
      )}>
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-surface-border flex-shrink-0">
          <h2 className="text-sm font-semibold text-slate-200">{titulo}</h2>
          <button
            onClick={onFechar}
            className="p-1.5 rounded-lg text-slate-500 hover:text-white hover:bg-surface-card transition-colors"
          >
            <X size={16} />
          </button>
        </div>

        {/* Body com scroll */}
        <div className="overflow-y-auto flex-1 px-5 py-4">
          {children}
        </div>
      </div>
    </div>
  );
}
